(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["arms-of-mercy-scripture"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = (context) => {
      context.querySelectorAll('[data-aom-scripture]').forEach(details => {
        if (details.dataset.ready) return;
        details.dataset.ready = 'true';
        const verse = details.querySelector('blockquote');
        const text = verse.textContent;
        const motion = matchMedia('(prefers-reduced-motion: reduce)');
        details.addEventListener('toggle', () => {
          verse.getAnimations({subtree:true}).forEach(animation => animation.cancel());
          verse.textContent = text;
          if (!details.open || motion.matches) return;
          const accessible = document.createElement('span');
          accessible.style.cssText = 'position:absolute;width:1px;height:1px;padding:0;overflow:hidden;clip-path:inset(50%);white-space:nowrap';
          accessible.textContent = text;
          const visual = document.createElement('span');
          visual.setAttribute('aria-hidden', 'true');
          let index = 0;
          text.split(/(\s+)/).forEach(token => {
            if (/^\s+$/.test(token)) { visual.append(token); index += token.length; return; }
            const word = document.createElement('span');
            word.className = 'aom-scripture__word';
            Array.from(token).forEach(character => {
              const letter = document.createElement('span');
              letter.className = 'aom-scripture__letter';
              letter.textContent = character;
              word.append(letter);
              letter.animate([
                {opacity:0,filter:'blur(3px)',transform:'translateY(3px)'},
                {opacity:1,filter:'blur(0)',transform:'translateY(0)'}
              ], {duration:260,delay:index++ * 7,easing:'ease-out',fill:'both'});
            });
            visual.append(word);
          });
          verse.replaceChildren(accessible,visual);
        });
        motion.addEventListener('change', () => {
          if (!motion.matches) return;
          verse.getAnimations({subtree:true}).forEach(animation => animation.cancel());
          verse.textContent = text;
        });
      });
    };
    initialize(document);
    document.addEventListener('shopify:section:load', event => initialize(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["journey-home-guided-choices"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('journey-home-guided-choices')) {
    customElements.define('journey-home-guided-choices', class JourneyHomeGuidedChoices extends HTMLElement {
      connectedCallback() {
        Promise.all([
          customElements.whenDefined('variant-selects'),
          customElements.whenDefined('pickup-availability')
        ]).then(() => this.initialize());
      }

      initialize() {
        if (this.initialized) return;

        this.initialized = true;
        this.selector = document.getElementById(`variant-selects-${this.dataset.sectionId}`);
        this.cards = Array.from(this.querySelectorAll('[data-guided-choice]'));

        if (!this.selector || !this.cards.length) return;

        this.selector.before(this);
        this.variants = JSON.parse(this.selector.querySelector('script[type="application/json"]').textContent);
        this.cards.forEach((card) => card.addEventListener('click', () => this.selectVariant(card.dataset.variantId)));
        this.querySelectorAll('[data-guided-toggle]').forEach((toggle) => {
          toggle.addEventListener('click', () => this.toggleDescription(toggle));
        });
        this.selector.addEventListener('change', () => window.setTimeout(() => this.syncSelectedState(), 0));
        document.addEventListener('product:variant-change', (event) => {
          if (String(event.detail?.sectionId) === String(this.dataset.sectionId)) this.syncSelectedState(event.detail?.variant?.id);
        });

        const requestedVariantId = new URL(window.location.href).searchParams.get('variant');
        const hasValidRequestedVariant = this.variants.some((variant) => String(variant.id) === String(requestedVariantId));

        if (!hasValidRequestedVariant) {
          this.selectVariant(this.dataset.defaultVariantId);
        } else {
          this.syncSelectedState(requestedVariantId);
        }
      }

      selectVariant(variantId) {
        const variant = this.variants.find((item) => String(item.id) === String(variantId));

        if (!variant) return;

        const fieldsets = Array.from(this.selector.querySelectorAll('fieldset'));
        let changedControl;

        fieldsets.forEach((fieldset, index) => {
          const optionValue = variant.options[index];
          const select = fieldset.querySelector('select');

          if (select) {
            select.value = optionValue;
            changedControl = select;
            return;
          }

          const radio = Array.from(fieldset.querySelectorAll('input[type="radio"]')).find((input) => input.value === optionValue);

          if (radio) {
            radio.checked = true;
            changedControl = radio;
          }
        });

        if (changedControl) changedControl.dispatchEvent(new Event('change', { bubbles: true }));
        this.syncSelectedState(variant.id);
      }

      toggleDescription(toggle) {
        const description = this.querySelector(`#${CSS.escape(toggle.getAttribute('aria-controls'))}`);

        if (!description) return;

        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        description.hidden = expanded;
        toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        toggle.querySelector('[data-guided-toggle-label]').textContent = expanded ? toggle.dataset.readMore : toggle.dataset.close;
      }

      syncSelectedState(variantId) {
        const currentId = variantId || this.selector.currentVariant?.id || this.getSelectedVariantId();

        this.cards.forEach((card) => {
          const selected = String(card.dataset.variantId) === String(currentId);
          card.closest('.journey-home-guided-choice')?.classList.toggle('is-selected', selected);
          card.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
      }

      getSelectedVariantId() {
        const selectedOptions = Array.from(this.selector.querySelectorAll('fieldset')).map((fieldset) => {
          const select = fieldset.querySelector('select');
          return select ? select.value : fieldset.querySelector('input[type="radio"]:checked')?.value;
        });
        return this.variants.find((variant) => variant.options.every((option, index) => option === selectedOptions[index]))?.id;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
